import { ChevronLeftIcon } from 'lucide-react';

interface BackLinkProps {
  onClick: () => void;
  disabled?: boolean;
}

export function BackLink({ onClick, disabled }: BackLinkProps) {
  return (
    <button
      type="button"
      className="sm-type-body-strong sm-focus-ring sm-back"
      onClick={onClick}
      disabled={disabled}
    >
      <ChevronLeftIcon className="sm-back-icon" aria-hidden="true" />
      Back
    </button>
  );
}
